$(document).ready(function () {
    'use strict';
    // FOR MULTI-LANGUAGE SELECT BOX 'navigation/language_switch.twig'
    $('.languageSelect').on('change', function () {
        var url = $(this).val(); // get selected value
        if (url) { // require a URL
            window.location = url; // redirect
        }
        return false;
    });
});
